// src/utils/divisions.js

export class Division {
  constructor({ name, district }) {
    this.name = name;
    this.district = district;
  }

  toJSON() {
    return {
      name: this.name,
      district: this.district,
    };
  }

  get displayName() {
    return `${this.name}`;
  }

  get displayWithDistrict() {
    return `${this.name} (${this.district})`;
  }

  matchesSearch(searchTerm) {
    if (!searchTerm) return true;
    const term = searchTerm.toLowerCase().trim();
    return (
      this.name.toLowerCase().includes(term) ||
      this.district.toLowerCase().includes(term)
    );
  }
}

// Kampala Divisions
export const kampalaDivisions = [
  new Division({ name: 'Central Division', district: 'Kampala' }),
  new Division({ name: 'Kawempe Division', district: 'Kampala' }),
  new Division({ name: 'Makindye Division', district: 'Kampala' }),
  new Division({ name: 'Nakawa Division', district: 'Kampala' }),
  new Division({ name: 'Rubaga Division', district: 'Kampala' }),
];

// Wakiso Divisions
export const wakisoDivisions = [
  new Division({ name: 'Entebbe Municipality', district: 'Wakiso' }),
  new Division({ name: 'Kajjansi Town Council', district: 'Wakiso' }),
  new Division({ name: 'Kakiri Town Council', district: 'Wakiso' }),
  new Division({ name: 'Kasangati Town Council', district: 'Wakiso' }),
  new Division({ name: 'Katabi Town Council', district: 'Wakiso' }),
  new Division({ name: 'Kira Municipality', district: 'Wakiso' }),
  new Division({ name: 'Makindye Ssabagabo Municipality', district: 'Wakiso' }),
  new Division({ name: 'Nansana Municipality', district: 'Wakiso' }),
  new Division({ name: 'Ssisa Sub-county', district: 'Wakiso' }),
  new Division({ name: 'Busiro East County', district: 'Wakiso' }),
  new Division({ name: 'Busiro North County', district: 'Wakiso' }),
  new Division({ name: 'Busiro South County', district: 'Wakiso' }),
];

// Mukono Divisions
export const mukonoDivisions = [
  new Division({ name: 'Mukono Municipality', district: 'Mukono' }),
  new Division({ name: 'Goma Sub-county', district: 'Mukono' }),
  new Division({ name: 'Nakisutu Sub-county', district: 'Mukono' }),
  new Division({ name: 'Ntenjeru Sub-county', district: 'Mukono' }),
  new Division({ name: 'Koome Islands Sub-county', district: 'Mukono' }),
  new Division({ name: 'Mpatta Sub-county', district: 'Mukono' }),
  new Division({ name: 'Kyampisi Sub-county', district: 'Mukono' }),
  new Division({ name: 'Nama Sub-county', district: 'Mukono' }),
  new Division({ name: 'Kasawo Sub-county', district: 'Mukono' }),
  new Division({ name: 'Seeta-Namuganga Town Council', district: 'Mukono' }),
  new Division({ name: 'Naggalama Town Council', district: 'Mukono' }),
  new Division({ name: 'Lugazi Municipality', district: 'Mukono' }),
];

// Master lookup — given a district name, returns its divisions
export const divisionsByDistrict = {
  'Kampala': kampalaDivisions,
  'Wakiso': wakisoDivisions,
  'Mukono': mukonoDivisions,
};

// Returns all divisions for the given districtName
export const getDivisionsForDistrict = (districtName) => {
  if (!districtName) return [];
  return divisionsByDistrict[districtName] || [];
};

// Returns all divisions across all districts
export const getAllDivisions = () => {
  const all = [];
  Object.values(divisionsByDistrict).forEach(divisionList => {
    all.push(...divisionList);
  });
  return all;
};

// Get divisions grouped by district
export const getDivisionsGroupedByDistrict = () => {
  const grouped = {};
  Object.entries(divisionsByDistrict).forEach(([district, divisionList]) => {
    grouped[district] = divisionList;
  });
  return grouped;
};

// Search divisions across all districts
export const searchDivisions = (searchTerm) => {
  if (!searchTerm) return getAllDivisions();
  const term = searchTerm.toLowerCase().trim();
  return getAllDivisions().filter(division => division.matchesSearch(term));
};

// Get district names that have divisions
export const getDistrictsWithDivisions = () => {
  return Object.keys(divisionsByDistrict);
};

export default {
  Division,
  kampalaDivisions,
  wakisoDivisions,
  mukonoDivisions,
  divisionsByDistrict,
  getDivisionsForDistrict,
  getAllDivisions,
  getDivisionsGroupedByDistrict,
  searchDivisions,
  getDistrictsWithDivisions,
};